import { create } from 'zustand';

import { GetUsers } from '../api';

import { resetUsersPage } from './use-users-pagination-store';
import { omit } from '@/utils';

type GetUsersParam = GetUsers['param'];

export type UseUsersFilterStore = {
  userId: string;
  searchString: GetUsersParam['searchString'];
  status: string[];
};

const defaultValue: UseUsersFilterStore = {
  userId: '',
  searchString: '',
  status: [],
};

export const useUsersFilterStore = create<UseUsersFilterStore>(() => ({
  ...defaultValue,
}));

export const useSearchFilter = () =>
  useUsersFilterStore((state) => state.searchString);

export const useStatusFilter = () =>
  useUsersFilterStore((state) => state.status);

export const useUsersFilter = () => useUsersFilterStore((state) => state);

export const setSearchStringFilter = (
  searchString: UseUsersFilterStore['searchString'],
) => {
  useUsersFilterStore.setState({ searchString });
  resetUsersPage();
};

export const setStatusFilter = (status: UseUsersFilterStore['status']) => {
  useUsersFilterStore.setState({ status });
  resetUsersPage();
};

export const resetHiddenFilters = () => {
  useUsersFilterStore.setState({
    ...omit(defaultValue, ['searchString']),
  });
};

export const resetUsersFilterStore = () => {
  useUsersFilterStore.setState({ ...defaultValue });
  resetUsersPage();
};
